import { useEffect, useState } from "react"
import { UsercentricsServices } from "../types/usercentrics"
import { extractServicesFromStorage } from "../utils/cookie-solution-utils"

function useConsentStatus(serviceId: string): boolean {
  const [services, setServices] = useState<UsercentricsServices>(extractServicesFromStorage())

  useEffect(() => {
    function handleConsentChange() {
      setServices(extractServicesFromStorage())
    }

    window.addEventListener("ucConsentEvent", handleConsentChange)

    return () => {
      window.removeEventListener("ucConsentEvent", handleConsentChange)
    }
  }, [])

  return services[serviceId] ?? false
}

export default useConsentStatus
